import styled from 'styled-components'

import { Color } from '../../../../theme/color'
import { RowBetween } from '../../../../components/common'

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`

export const Item = styled.li<{ itemGap?: number; isBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ itemGap }) => `gap: ${itemGap}px;`}
  margin-bottom: 16px;
  padding-bottom: 8px;
  ${({ isBorder }) => (isBorder ? `border-bottom: 1px solid ${Color.line};` : '')}
  list-style: none;
`

export const ContentsContainer = styled(RowBetween)`
  > * {
    width: 100%;
    padding: 8px 0;
  }
`

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 500;
`
